/**
 * This file is only used for web. It's a placeholder for the web implementation of the remote notifications and to prevent errors when building the web app.
 */

import { noop } from 'lodash';

export const messageHandler = noop;
